module.exports = __webpack_public_path__ + "img/rev.mng-dark.b55d6597.svg";